import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { isEmpty, isNull, isUndefined } from 'lodash';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';
import ChooseOneSlideOptions from './ChooseOneSlideOptions';
import { RuntimeContext } from '../../../../common/RuntimeContext';

export class ChooseOnePathSlide extends Component {
    static propTypes = {
        canMoveToNext: PropTypes.func,
        onNext: PropTypes.func,
        onChange: PropTypes.func,
        completedData: PropTypes.object,
        content: PropTypes.shape({
            options: PropTypes.array,
            description: PropTypes.string,
            displayType: PropTypes.string,
            includeChoiceLabels: PropTypes.bool,
            otherTextEnabled: PropTypes.bool
        }),
        currentUser: PropTypes.object,
        hideBookmark: PropTypes.bool,
        isRequired: PropTypes.bool,
        isUpdatingUserTrack: PropTypes.bool,
        isWelcomeWorkspace: PropTypes.bool,
        isReflectionWorkspace: PropTypes.bool,
        name: PropTypes.string,
        nextSectionName: PropTypes.string,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        sendWorkspaceSegementEvent: PropTypes.func,
        userResponses: PropTypes.object,
        setRoles: PropTypes.func,
        setResponseVariables: PropTypes.func,
        responseVariableName: PropTypes.string,
        currentSubSlide: PropTypes.number,
        reflectionDescription: PropTypes.string,
        isRefSheet: PropTypes.bool,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            selectChoice: props.completedData ? props.completedData.data : ''
        };
    }

    componentDidMount() {
        const {
            canMoveToNext,
            onChange,
            completedData = {},
            isRequired = false,
            sectionItemId,
            name,
            userResponses
        } = this.props;

        if (userResponses && userResponses?.byParentId[sectionItemId]) {
            this.setState({ selectChoice: userResponses?.byParentId[sectionItemId].answer[0].id });
        } else {
            canMoveToNext(!isEmpty(completedData) || !isRequired);
        }

        if (!isRequired && isEmpty(completedData)) {
            const isCompleted = true;

            const isAnswered = false;
            onChange(null, isCompleted, isAnswered);
        }
    }

    /**
     *
     * @param choice
     */
    handleOptionSelect = (choice, responseVariableChoice) => {
        const {
            onChange,
            isUpdatingUserTrack,
            canMoveToNext,
            setRoles,
            sectionItemId,
            setResponseVariables,
            responseVariableName,
            onNext
        } = this.props;
        this.setState({
            selectChoice: choice
        });
        const isCompleted = true;
        if (setRoles) {
            setRoles(sectionItemId, choice);
        }

        if (!isNull(responseVariableChoice) && !isUndefined(responseVariableChoice)) {
            setResponseVariables(responseVariableName, responseVariableChoice);
        }

        if (onChange) {
            onChange(choice, isCompleted, Boolean(choice));
        }

        if (!isUpdatingUserTrack) {
            canMoveToNext(true);
        }
        if (onNext) {
            onNext();
        }
    };

    onOtherOptionChange = (event, choice) => {
        const {
            onChange,
            isUpdatingUserTrack,
            canMoveToNext,
            content: { otherTextEnabled }
        } = this.props;
        const { value } = event.target;
        this.setState({
            selectChoice: choice
        });

        const isCompleted = true;

        if (!isUpdatingUserTrack && (!!value || !otherTextEnabled)) {
            canMoveToNext(true);
        }

        const isAnswered = !!value;
        if (onChange) {
            onChange(`${choice}::::${value || ''}`, isCompleted, isAnswered);
        }
    };

    render() {
        const {
            currentUser,
            name,
            nextSectionName,
            content: { displayType, options = [], description = '', includeChoiceLabels },
            sectionId,
            sectionItemId,
            hideBookmark,
            completedData,
            isWelcomeWorkspace,
            sendWorkspaceSegementEvent,
            reflectionDescription,
            isReflectionWorkspace = false,
            currentSubSlide,
            isRefSheet = false,
        } = this.props;
        const isImageType = displayType === 'image';
        const optionsStyle = displayType === 'boxes' ? 'options-block' : '';
        return (
            <div className={'chooseSlide'}>
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div
                    className={cns('chooseSlide-options', 'playerContent', {
                        'chooseOnePathSlide-options': isReflectionWorkspace && displayType === 'buttons'
                    })}
                >
                    {isReflectionWorkspace && currentSubSlide === 1 && reflectionDescription ? (
                        <RichTextDisplay
                            className={'reflection-description'}
                            htmlToDisplay={reflectionDescription}
                            currentUser={currentUser}
                            nextSectionName={nextSectionName}
                        />
                    ) : null}
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    <div className={cns('options', optionsStyle, { 'chooseSlide-options-images': isImageType })}>
                        <ChooseOneSlideOptions
                            isImageType={isImageType}
                            includeChoiceLabels={includeChoiceLabels}
                            handleOptionSelect={this.handleOptionSelect}
                            selectChoice={this.state.selectChoice}
                            options={options}
                            isWelcomeWorkspace={isWelcomeWorkspace}
                            onOtherOptionChange={this.onOtherOptionChange}
                            completedData={completedData}
                            displayType={displayType}
                            isReflectionWorkspace={isReflectionWorkspace}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default TrackPlayerSlideComponent(ChooseOnePathSlide);
